export const ENGAGEMENT_TYPE_KEY = 'engagement_type';

export const ASM = 'asm';
export const BRAND_ABUSE = 'brand_abuse';
export const DARKWEB = 'darkweb';
export const BRONZE = 'bronze';
export const SILVER = 'silver';
export const GOLD = 'gold';
export const PLATINUM = 'platinum';
export const DEMO = 'demo';
export const POC = 'poc';
export const UNMANAGED_POC = 'unmanaged_poc';
export const SIZING = 'sizing';
export const REPORT = 'report';
export const INTERNAL_USE = 'internal_use';
export const PRODUCTION_CUSTOMER = 'production_customer';
export const TEM_ESSENTIALS = 'tem_essentials';
export const MSSP_MGMT = 'mssp_management';
export const MSSP_MGMT_DEMO = 'mssp_management_demo';
export const MSSP_MGMT_POC = 'mssp_management_poc';
export const MSSP_MGMT_UNMANAGED_POC = 'mssp_management_unmanaged_poc';
